/* Two-column drawer layout */

.drawerLayout {
    display: flex;
    align-items: stretch;
}

.connectorSidebar {
    flex: 0 0 240px;
    padding: 24px 20px;
    border-radius: 10px;
    background: var(--exo-color-background-secondary);
    display: flex;
    flex-direction: column;
    gap: 12px;
}

.connectorSidebarName {
    font-size: 15px;
    font-weight: 700;
    color: var(--exo-color-font);
}

.connectorSidebarDescription {
    font-size: 13px;
    color: var(--exo-color-font-secondary);
    line-height: 1.5;
}

.formColumn {
    flex: 1;
    padding: 24px;
    min-width: 0;
}

.connectorIcon {
    flex-shrink: 0;
    border-radius: 12px;
    padding: 8px;
    background: var(--exo-color-background);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

:global(.ex-theme-dark) .connectorIcon {
    background: #f0f0f0;
    border: 1px solid rgba(0, 0, 0, 0.06);
}
